import { render } from '@mairistem/module';
import React from 'react';
import ReactDOM from 'react-dom';
import AppSimulation from './AppSimulation';
import { initialize } from './sentry';
import '@mairistem/comptabilite/comptabilite.css';
import '@mairistem/finances-utils/finances-utils.css';

const code = '360_EDB';

// Ne pas modifier ou supprimer
// Utile en mode production afin que le style se place au bon endroit
if (process.env.NODE_ENV !== 'development') {
	const oldCreatePortal = ReactDOM.createPortal;

	ReactDOM.createPortal = (child, domNode) =>
		oldCreatePortal(
			child,
			domNode === document.body
				? document.querySelector(`#${CSS.escape(code)}`) || domNode
				: domNode || document.querySelector(`#${CSS.escape(code)}`),
		);
}

initialize();

render(<AppSimulation />);
